import { createRoot, type Root, hydrateRoot } from 'react-dom/client';
import { App } from '../App';

export const renderReactApp = (
    mountPoint: HTMLElement,
    moduleName: string,
    props: Record<string, string>,
    appState?: Record<string, string>
): Root => {
    if (mountPoint.innerHTML.trim()) {
        // If mountpoint has content, hydrate it
        return hydrateRoot(
            mountPoint,
            <App moduleName={moduleName} appState={appState} {...props} />,
            {
                onRecoverableError: error => {
                    console.info(
                        'Error while hydrating the module:',
                        moduleName,
                        '\n',
                        error
                    );
                },
            }
        );
    } else {
        // Create Root
        const root = createRoot(mountPoint);
        root.render(<App moduleName={moduleName} {...props} />);
        return root;
    }
};

export type TRenderReactApp = typeof renderReactApp;

export const updateReactApp = (
    root: Root,
    moduleName: string,
    props: Record<string, string>
) => {
    root.render(<App moduleName={moduleName} {...props} />);
};

export type TUpdateReactApp = typeof updateReactApp;
